import React from 'react';
import { PiFileText, PiSparkle } from 'react-icons/pi';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { MessageMediaProcessing } from 'src/api/generated';
import { Text } from 'src/modules/shared/components/atoms/text';

interface MediaProcessingButtonsProps {
  mediaProcessing?: MessageMediaProcessing;
  onShowText: (content: string, type: 'textRepresentation' | 'summary') => void;
  className?: string;
}

export const MediaProcessingButtons: React.FC<MediaProcessingButtonsProps> = ({
  mediaProcessing,
  onShowText,
  className = '',
}) => {
  if (!mediaProcessing) return null;

  const { textRepresentation, summary } = mediaProcessing;
  const hasTextRep =
    textRepresentation?.status === 'completed' && textRepresentation.content;
  const hasSummary = summary?.status === 'completed' && summary.content;

  if (!hasTextRep && !hasSummary) return null;

  return (
    <div className={`flex justify-start items-center gap-2 pb-4 ${className}`}>
      {hasSummary && (
        <Button
          appearance="soft"
          size="xs"
          onClick={() => onShowText(summary.content!, 'summary')}
          title="Ver resumen"
        >
          <div className="flex items-center gap-2">
            <PiSparkle className="w-4 h-4 text-primary-600" />
            <Text size="tiny" color="primary" weight="medium">
              {/* TODO: check when implementing i18n */}
              Resumen
            </Text>
          </div>
        </Button>
      )}

      {hasTextRep && (
        <Button
          appearance="soft"
          size="xs"
          onClick={() =>
            onShowText(textRepresentation.content!, 'textRepresentation')
          }
          title="Ver descripción detallada"
        >
          <div className="flex items-center gap-2">
            <PiFileText className="w-4 h-4 text-primary-600" />
            <Text size="tiny" color="primary" weight="medium">
              {/* TODO: check when implementing i18n */}
              Descripción
            </Text>
          </div>
        </Button>
      )}
    </div>
  );
};
